import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Overlay from '@/forms/_common/Overlay';
import FormErrors from '@/forms/_common/FormErrors';
import RequestError from '@/forms/_common/RequestError';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import Form from './Form';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';

Dialog.propTypes = {
  project: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};

export default function Dialog(props) {
  const { project, onClose, onSubmit } = props;

  const [data, setData] = useState({
    galleryStatus: project.data.galleryStatus,
    featuredAt: project.data.featuredAt
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('project.update', project);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onSubmit?.(request);
    }
  }, [success, onSubmit, request]);

  function handleSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    setData((prevData) => ({...prevData, [name]: value}));
  }

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>

        <FormErrors data={data} validators={{
          // confirmation: [validators.isValue('PUBLISH')]
        }}>
          {({hasError}) => {
            if (success) {
              return (
                <Confirmation
                  onClose={() => {
                    onClose();
                    setTimeout(function() {
                      onSubmit?.(request);
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : handleSubmit()}
                onClose={onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : null}
                project={project}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
